import React, { PureComponent } from "react"
import {
    Avatar,
    Checkbox,
    Chip,
    IconButton,
    InputLabel,
    FormControl,
    FormControlLabel,
    ListItemText,
    ListItem,
    ListItemIcon,
    MenuItem,
    Select,
    TextField,
    Toolbar
} from "@material-ui/core"
import Autocomplete, {
    createFilterOptions,
  } from "@material-ui/lab/Autocomplete";
import SearchIcon from '@material-ui/icons/Search';
import TagIcon from "@material-ui/icons/Brightness1";
import { withTheme } from "@material-ui/core/styles"
import moment from 'moment'

const filterTag = createFilterOptions();
class StatsFilterToolbar extends PureComponent {
    constructor(props) {
        super(props)
        let lastMonth = moment()
        lastMonth = lastMonth.add(-1, "month").format("YYYY-MM-DD")
        const today = moment().format("YYYY-MM-DD")
        this.state = {
            from: lastMonth,
            to: today,
            place: "",
            status: "",
            onlyGift: false,
            user: "",
            tags:[]
        }
        this.onFilter = this.onFilter.bind(this)
        this.onSelectFilterTag = this.onSelectFilterTag.bind(this)
    }

    onDeleteRenderTag(type, tag) {
        let newTags = null;
        let idx = -1;
        if (type == "add") {
            newTags = this.state.tags.slice(0);
            idx = newTags.findIndex((t) => t.id == tag.id);
            if (idx >= 0) {
                newTags.splice(idx, 1);
            }
            this.setState({ tags: newTags });
        }
        if (type == "filter") {
            newTags = this.state.tags.slice();
            idx = newTags.findIndex((t) => t.id == tag.id);
            if (idx >= 0) {
                newTags.splice(idx, 1);
            }
            this.setState({ tags: newTags });
        }
        console.log("ON DELETE RENDER TAG", type, tag, idx);
    }

    onSelectFilterTag(evt, tags) {
        this.setState({ tags: tags });
    }

    renderTags(type, tags) {
        const { theme } = this.props
        let t = tags && tags.filter((t) => !t.add);
        return (
          t &&
          t.map((tag) => (
            <Chip
              label={tag.tagName}
              onDelete={this.onDeleteRenderTag.bind(this, type, tag)}
              avatar={
                <Avatar
                  style={{ backgroundColor: tag.tagColor, color: theme.palette.getContrastText(tag.tagColor) }}
                >
                  {tag.tagName.substring(0, 1)}
                </Avatar>
              }
            />
          ))
        );
    }

    onChangeFilter(field, evt) {
        let filter = { ...this.state }
        filter[field] = field == "onlyGift" ? evt.target.checked : evt.target.value
        this.setState(filter)
    }

    onFilter(evt) {
        this.props.onSearch(this.state)
    }

    render() {
        const { tagList, placeList, theme } = this.props
        const { from, to, status, onlyGift, place, user } = this.state
        return (
            <Toolbar style={{ ...theme.table.toolbar, justifyContent: "space-between" }} >
                <TextField
                    value={from}
                    label="Fecha desde"
                    type="date"
                    InputLabelProps={{ shrink: true }}

                    onChange={this.onChangeFilter.bind(this, "from")}
                />
                <TextField
                    value={to}
                    label="Fecha hasta"
                    type="date"
                    InputLabelProps={{ shrink: true }}

                    onChange={this.onChangeFilter.bind(this, "to")}
                />
                <FormControl>
                    <InputLabel id="statusLabel" shrink>Estado</InputLabel>
                    <Select
                        labelId="statusLabel"
                        value={status}
                        onChange={this.onChangeFilter.bind(this, "status")}
                        displayEmpty

                    >
                        <MenuItem value=""><em>Todos los estados</em></MenuItem>
                        <MenuItem value="pendingUse">Sin usar</MenuItem>
                        <MenuItem value="already_used">Usado</MenuItem>
                    </Select>
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        label="Solo invitaciones"
                        control={
                            <Checkbox
                                color="primary"
                                checked={onlyGift}
                                onChange={this.onChangeFilter.bind(this, "onlyGift")}
                            />
                        }
                    />
                </FormControl>
                <FormControl>
                    <InputLabel id="placeLabel" shrink>Ubicación</InputLabel>
                    <Select
                        labelId="placeLabel"
                        value={place}
                        onChange={this.onChangeFilter.bind(this, "place")}
                        displayEmpty
                    >
                        <MenuItem value=""><em>Todas las ubicaciones</em></MenuItem>
                        {placeList && placeList.map((p) => <MenuItem value={p.id}>{p.plcName}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl style={{width:150}}>
                    <Autocomplete
                        options={tagList}
                        value={this.state.tags}
                        getOptionLabel={(option) => option.tagName}
                        renderInput={(params) => (
                            <TextField {...params} fullWidth label="Filtrar por tags" />
                        )}
                        renderOption={(t) => (
                            <ListItem>
                            <ListItemIcon>
                                <TagIcon style={{ color: t.tagColor }} />
                            </ListItemIcon>
                            <ListItemText primary={t.tagName} />
                            </ListItem>
                        )}
                        renderTags={this.renderTags.bind(this, "filter")}
                        onChange={this.onSelectFilterTag}
                        loadingText="Cargando tags ..."
                        noOptionsText="Sin tags"
                        selectOnFocus
                        multiple
                        filterSelectedOptions
                    />
                </FormControl>
                <TextField
                    style={{width:220}}
                    value={user}
                    label="Usuario"
                    InputLabelProps={{ shrink: true }}
                    placeholder="DNI, email, nombre o apellido"
                    onChange={this.onChangeFilter.bind(this,"user")}
                />  
                
                <IconButton onClick={this.onFilter}>
                    <SearchIcon />
                </IconButton>
            </Toolbar>
        )

    }
}

export default withTheme(StatsFilterToolbar)


// WEBPACK FOOTER //
// ./src/screens/statistics/StatsFilterToolbar.js